export const getLeftTopFromCenter = (width, height) => {
    if (typeof window !== `undefined`) {
        return {
            left: (window.innerWidth - width) / 2,
            top: (window.innerHeight - height) / 2,
        };
    }
    return { left: 0, top: 0 };
};